import { defineComponent as _defineComponent } from 'vue'
import { getProgress } from '@/api/shopify/optionSets';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SetProgression',
  props: {
    taskIdentifier: null
  },
  setup(__props: any) {

const props = __props as {
    taskIdentifier: string;
};



const showLoader = ref(true);
const progress = ref<number | null>(0);
const updateProgress = async () => {
    progress.value = await getProgress(props.taskIdentifier);
    if (progress.value === 100) {
        onProgressComplete();
    } else {
        setTimeout(updateProgress, 3000);
    }
};

const onProgressComplete = () => {
    showLoader.value = false;
};

onMounted(() => {
    updateProgress();
});

return { __sfc: true,props, showLoader, progress, updateProgress, onProgressComplete }
}

})